import { styled, TableBody as MuiTableBody } from '@mui/material';

export const TableBody = styled(MuiTableBody)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  width: '100%',
}));
